export default "__VITE_ASSET__XRDUIP3D__"